export const DRAG_THRESHOLD = 6;
export const INITIAL_SCALE = 1;
export const MIN_SCALE = 1;
export const MAX_SCALE = 5;
export const SCALE_TOLERANCE = 0.001;
export const BUTTON_ZOOM_STEP = 0.35;
export const BUTTON_ZOOM_ANIMATION_TIME = 160;
export const BUTTON_ZOOM_ANIMATION_TYPE = 'easeOutCubic' as const;
export const WHEEL_SMOOTH_STEP = 0.0012;
export const RESET_ANIMATION_TIME = 120;
export const RESET_ANIMATION_TYPE = 'easeOut' as const;
